<template>
  <path
    d="M22 4.00024C22 2.90024 21.1 2.00024 20 2.00024H4C2.9 2.00024 2 2.90024 2 4.00024V16.0002C2 17.1002 2.9 18.0002 4 18.0002H18L22 22.0002V4.00024Z"
  />
</template>
